/*
 * @Author: your name
 * @Date: 2022-04-10 21:06:26
 * @LastEditTime: 2022-04-10 22:06:04
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jk_one-stop_cloud_mobile_v1.0\src\store\modules\serachPrams.js
 */
import Vue from 'vue'
const serach = {
    state: {
        columns: [],
        params: {}
    },
    mutations: {
        columns_change: (state, record) => {
            console.log("columns" + record)
            // state.columns = []
            state.columns = record

        },
        params_change: (state, record) => {
            console.log( record)
            state.params = {}
            state.params = record

        }
    },
    actions: {
        changeColumns({ commit }, record) {
            commit('columns_change', record)
        },
        changeParams({ commit }, record) {
            commit('params_change', record)
        }
    }
}
export default serach